var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1743_2215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.667 46C36.3695 46 46.667 35.7025 46.667 23C46.667 10.2975 36.3695 0 23.667 0C10.9644 0 0.666992 10.2975 0.666992 23C0.666992 35.7025 10.9644 46 23.667 46Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1932 14.3477H16.1403C15.5388 14.3477 14.9431 14.4662 14.3874 14.6965C13.8317 14.9268 13.3268 15.2643 12.9016 15.6898C12.4763 16.1153 12.1391 16.6205 11.9092 17.1763C11.6793 17.7322 11.5611 18.3279 11.5615 18.9295V27.0703C11.5611 27.6718 11.6793 28.2676 11.9092 28.8235C12.1391 29.3793 12.4763 29.8845 12.9016 30.31C13.3268 30.7355 13.8317 31.073 14.3874 31.3033C14.9431 31.5336 15.5388 31.6521 16.1403 31.6521H31.1932C31.7948 31.6521 32.3904 31.5336 32.9462 31.3033C33.5019 31.073 34.0068 30.7355 34.432 30.31C34.8572 29.8845 35.1944 29.3793 35.4244 28.8235C35.6543 28.2676 35.7724 27.6718 35.7721 27.0703V18.9295C35.7724 18.3279 35.6543 17.7322 35.4244 17.1763C35.1944 16.6205 34.8572 16.1153 34.432 15.6898C34.0068 15.2643 33.5019 14.9268 32.9462 14.6965C32.3904 14.4662 31.7948 14.3477 31.1932 14.3477ZM20.4771 26.7102V19.2896L26.8565 22.9999L20.4771 26.7102Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1743_2215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(0.666992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.32e09c63d2925a67c50eaea17e2c66e7.svg";
export { ForwardRef as ReactComponent };